
import { useEffect, useState } from 'react'
import Select from 'react-select'
import { MonthDDLAPI } from '../../Redux/DDLSlice';
import { useDispatch, useSelector } from 'react-redux';
import { useAuthState } from '../../Helper/Context';

export const MonthHeaderDDL = (props) => {
    const { MLable, HMonth, flag, col } = props

    const userDetails = useAuthState();
    const { year, setYear, Month, setMonth, Ward, setWard, CurrentYear, CurrentMonth } = userDetails
    const { UserID, token, } = userDetails.user
    const dispatch = useDispatch()


    const d = new Date();
    let month = d.getMonth();

    const [MonthID, setMonthID] = useState(month + 1)

    useEffect(() => {
        const data = { UserID, token }
        dispatch(MonthDDLAPI({ data }))
    }, [])

    const { MonthData } = useSelector(state => state.MonthDDLData)

    useEffect(() => {
        handleMonthDDL()
    }, [MonthData])


    const handleMonthDDL = () => {
        // console.log(DeptDDLDataa)
        if (MonthData && MonthData.table && MonthData.table.length > 0) {
            let list = MonthData.table.map((item, index) => ({
                value: item.id,
                label: item.month_Name,
            }))
            if (flag == 'Screen') {
                setMonth({
                    DDL: list,
                    // ID: HMonth,
                    // Label: MLable,
                    ID: list[month].value,
                    Label: list[month].label,
                })
            } else {
                setMonth({
                    DDL: list,
                    ID: list[month].value,
                    Label: list[month].label,
                })
            }
        }
        else {
            setMonth({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }

    return (
        <div className={col && col == '10' ? "form-group col-lg-11" : "form-group mx-3 col-lg-3"}>
            {/* <label className="d-block" htmlFor="NameofDepartment"><b>Month :</b></label> */}
            {/* <select
                value={MonthID}
                onChange={(e) => (
                    setMonthID(e.target.value),
                    setMonth({ ...Month, ID: e.target.value, Label: e.target.name })
                )}
            // onChange={(e) => {
            //     e ?
            //         setMonth({ ...Month, ID: e.target.value, Label: e.label })
            //         :
            //         setMonth({ ...Month, ID: 0, Label: "Select..." })
            // }}
            >
                {
                    Month.DDL.map((item) => (
                        <option value={item.value} name={item.label}>{item.label}</option>
                    ))
                }
            </select> */}

            <Select
                // isRtl={isRtl}
                // styles={{
                //     option: (provided, state) => ({
                //         ...provided,
                //         color: 'black'
                //     })
                // }}
                styles={{
                    control: (baseStyles, state) => ({
                        ...baseStyles,
                        borderColor: state.isFocused ? null : 'transparent',
                        borderColor: '#878181',
                        boxShadow: 'none',
                        width: '115%',

                    }),
                    option: (provided, state) => ({
                        ...provided,
                        color: 'black'
                    })
                }}
                components={{
                    IndicatorSeparator: () => null
                }}
                value={{ value: Month.ID, label: Month.Label }}
                onChange={(e) => {
                    e ?
                        setMonth({ ...Month, ID: e.value, Label: e.label })
                        :
                        setMonth({ ...Month, ID: 0, Label: "Select..." })

                }}
                options={Month.DDL}
            />

        </div>
    )
}